"use strict";
import { esc, srTable } from "../util";
export function renderUpset(host, data) {
  host.innerHTML = "";
  host.classList.add("us-wrap");
  const sets = data.sets || [];
  const combos = (data.combinations || []).slice().sort((a, b) => b.count - a.count || a.members.length - b.members.length);
  const maxC = Math.max(1, ...combos.map((c) => c.count));
  const ROW = 30;
  const MAXBAR = 88;
  const BARZONE = 112;
  const idx = {};
  sets.forEach((s, i) => idx[s.label] = i);
  const matrixH = ROW * sets.length;
  if (data.title) host.insertAdjacentHTML("beforeend", `<h2 class="us-head">${esc(data.title)}</h2>`);
  if (data.subtitle) host.insertAdjacentHTML("beforeend", `<p class="us-sub">${esc(data.subtitle)}</p>`);
  let cols = "";
  combos.forEach((c) => {
    const members = c.members.map((m) => idx[m]).filter((v) => v != null).sort((a, b) => a - b);
    const bh = Math.round(c.count / maxC * MAXBAR);
    let dots = "";
    if (members.length > 1) {
      const top = members[0] * ROW + ROW / 2;
      const h = (members[members.length - 1] - members[0]) * ROW;
      dots += `<div class="us-line" style="top:${top}px;height:${h}px"></div>`;
    }
    for (let i = 0; i < sets.length; i++) {
      const on = members.includes(i);
      const cy = i * ROW + ROW / 2;
      dots += `<div class="us-dot ${on ? "on" : "off"}" style="top:${cy}px"></div>`;
    }
    cols += `<div class="us-col">
      <div class="us-barzone"><span class="us-cnt">${c.count}</span>
        <div class="us-bar" style="height:${bh}px"></div></div>
      <div class="us-matrix" style="height:${matrixH}px">${dots}</div></div>`;
  });
  let labels = `<div class="us-spacer" style="height:${BARZONE}px"></div>`;
  sets.forEach((s) => {
    labels += `<div class="us-setrow" style="height:${ROW}px">
      <span>${esc(s.label)}</span><span class="us-settot">${s.total}</span></div>`;
  });
  host.insertAdjacentHTML(
    "beforeend",
    `<div class="us-grid"><div class="us-labels">${labels}</div><div class="us-plot">${cols}</div></div>`
  );
  if (data.none_count != null) {
    host.insertAdjacentHTML(
      "beforeend",
      `<p class="us-note">${data.none_count} of ${data.total} reported no support needs and are not shown.</p>`
    );
  }
  if (data.source) host.insertAdjacentHTML("beforeend", `<p class="us-note">${esc(data.source)}</p>`);
  host.insertAdjacentHTML(
    "beforeend",
    srTable(
      data.title || "Support-need combinations",
      ["Combination", "People"],
      combos.map((c) => [c.members.join(" + "), c.count]).concat(data.none_count != null ? [["No needs reported", data.none_count]] : [])
    )
  );
}
